<template>
    <div id="app">
        {{ macAddress }}
        <transition name="el-fade-in-linear">
            <IndexPage></IndexPage>
        </transition>


        <div class="main">
            <transition name="el-fade-in" mode="out-in">
                <router-view></router-view>
            </transition>


        </div>
        <!-- <DialogCom :showModal="showModal" @confirm="confirm" :title="title" :body="body"></DialogCom> -->


    </div>
</template>

<script>
import IndexPage from '@/view/IndexPage/IndexPage'
// import DialogCom from "@/components/DialogCom";
// import { checkUpdate, installUpdate, onUpdaterEvent } from '@tauri-apps/api/updater';
// import {invoke} from "@tauri-apps/api/tauri";
// import { relaunch } from '@tauri-apps/api/process';
// import { invoke } from '@tauri-apps/api/tauri'




export default {
    name: 'App',
    components: {
        IndexPage,
        // DialogCom
    },
    data() {
        return {
            showModal: false,
            title: '',
            body: '',
            FingerprintStr: '',
            macAddress: '',

        }
    },


    computed: {
        key() {
            return this.$route.path
        }
    },
    mounted() {
        // setTimeout(() => {
        //     invoke('close_splashscreen')
        // }, 2000)
        // this.getMacAddress()



        // this.checkAndUpdate()

    },
    methods: {
        // 获取MAC地址时用的韩式
        // async getMacAddress() {
        //     try {
        //         const macAddress = await invoke('get_mac')
        //         this.macAddress = macAddress
        //         console.log('macAddress-->', macAddress)
        //     } catch (e) {
        //         console.log('e-->', e)
        //     }
        // },
        
        




        // async confirm(e) {
        //     try {
        //         if (e) {
        //             this.showModal = false
        //             this.$loading({
        //                 lock: true,
        //                 text: '正在更新。。',
        //                 spinner: 'fa fa-spinner fa-spin fa-lg',
        //                 background: 'rgba(0, 0, 0, 0.1)',

        //             });
        //             await installUpdate();
        //             await relaunch()


        //         } else {
        //             this.showModal = false
        //         }

        //     } catch (e) {
        //         console.log('e-->', e)
        //     }

        // },
        // async checkAndUpdate() {
        //     // Add your code here
        //     const unlisten = await onUpdaterEvent(({ error, status }) => {
        //         // This will log all updater events, including status updates and errors.
        //         console.log('Updater event', error, status)
        //     })

        //     try {
        //         const { shouldUpdate, manifest } = await checkUpdate()
        //         if (shouldUpdate) {
        //             this.title = `发现新版本 ${manifest?.version}`
        //             this.body = `需要更好的体验，即使更新`
        //             this.showModal = true


        //         }
        //     } catch (error) {
        //         console.error(error)
        //         // await installUpdate()
        //         // await relaunch()
        //     }

        //     // you need to call unlisten if your handler goes out of scope, for example if the component is unmounted.
        //     unlisten()
        // },


    },

}
</script>

<style>
#app {
    /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
    /*-webkit-font-smoothing: antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
    /*text-align: center;*/
    color: #2c3e50;
    overflow-y: auto;
    width: 100%;

    /*margin-top: 60px;*/
}

.main {
    margin-top: 90px;
    z-index: -9999;
    width: 100%;
    position: absolute;
    padding-left: 0;


}
</style>
